import { NgModule } from '@angular/core';

import { KeysPipe } from './keys.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { FilterPipe } from './filter.pipe';
import { CamelCaseToDashPipe } from './camelCaseToDash.pipe';
import { HtmlWithStylePipe } from './htmlWithStyle.pipe';
import { FullTextSearchPipe } from './registries-list.pipe';
import { ArraySortPipe } from './sort.pipe';

@NgModule({
    declarations: [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        HtmlWithStylePipe,
        FullTextSearchPipe,
        ArraySortPipe
    ],
    imports     : [],
    exports     : [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        HtmlWithStylePipe,
        FullTextSearchPipe,
        ArraySortPipe
    ]
})
export class FusePipesModule
{
}
